// extracted by mini-css-extract-plugin
export default {"wrapper":"UserAccount_wrapper__zweAY","content":"UserAccount_content__GVhEt","mt":"UserAccount_mt__IY+KH","title":"UserAccount_title__8PeOn"};